import { RouteRecordRaw } from "vue-router";
import * as layouts from "@/widgets";
import * as pages from "@/pages";

const router: RouteRecordRaw = {
  name: "index",
  path: "",
  redirect: { name: "home-page" },
  component: layouts.BaseLayout,
  children: [
    {
      path: "home",
      name: "home-page",
      component: pages.HomePage,
    },
    {
      path: "contact-us",
      name: "contact-us",
      component: pages.ContactUs,
    },
    {
      path: "about-us",
      name: "about-us",
      component: pages.AboutUs,
    },
    {
      path: "products-and-services",
      name: "products-services",
      component: pages.ProductsServices,
    },
    {
      path: "news",
      name: "news",
      component: pages.NewsPage,
    },
    {
      path: "news-new-region-libya",
      name: "news1",
      component: pages.NewsOnePage,
    },
    {
      path: "news-runpay-ewallet",
      name: "news2",
      component: pages.NewsTwoPage,
    },
    {
      path: "news-runpay-pos-mini-o",
      name: "news3",
      component: pages.NewsThreePage,
    },
    {
      path: "news-runpay-ten-years-in-tunisia",
      name: "news4",
      component: pages.NewsFourPage,
    },
    {
      path: "news-runpay-linkedin",
      name: "news5",
      component: pages.NewsFivePage,
    },
    {
      path: "news-ten-year-in-moldova",
      name: "news6",
      component: pages.NewsSixPage,
    },
    {
      path: "news-runpay-qr-payments",
      name: "news7",
      component: pages.NewsSevenPage,
    },
    {
      path: "news-runpay-cryptovoucher",
      name: "news8",
      component: pages.NewsEightPage,
    },
    {
      path: "privacy-policy",
      name: "privacy-policy",
      component: pages.PrivacyPolicy,
    },
    {
      path: "documentation-consulting",
      name: "documentation-consulting",
      component: pages.DocumentationConsulting,
    },
    {
      path: "terminal-solution",
      name: "terminal-solution",
      component: pages.TerminalSolution,
    },
    {
      path: "saas",
      name: "saas",
      component: pages.Saas,
    },
    {
      path: "wiki/accountclosure",
      name: "account-close",
      component: pages.AccountClose,
    },
  ],
};
export default router;
